import React from 'react';
import { columnTransferable, columnViewing, hasColumn } from '@/constants/fields';
import AttachmentMessageCells from './AttachmentMessageCells';
import AttachmentViewingCell from './AttachmentViewingCell';
import AttachmentTransferableCell from './AttachmentTransferableCell';

const DatasetAttachmentManageCells = ({
  attachment,
  canManage,
  disabled,
  category,
  code,
  columns,
  isLoading,
  upward,
}) => {
  const hasView = hasColumn(columns, columnViewing);
  const hasTransfer = hasColumn(columns, columnTransferable);
  if (!hasView && !hasTransfer) { return null; }

  return (
    <>
      {canManage && hasView && (
        <AttachmentViewingCell
          attachment={attachment}
          category={category}
          code={code}
          disabled={disabled}
          isLoading={isLoading}
          upward={upward}
        />
      )}
      {canManage && hasTransfer && (
        <AttachmentTransferableCell
          attachment={attachment}
          category={category}
          code={code}
          disabled={disabled}
          isLoading={isLoading}
          upward={upward}
        />
      )}
      {!canManage && (<AttachmentMessageCells attachment={attachment} hasTransfer={hasTransfer} hasView={hasView} />)}
    </>
  );
};

export default DatasetAttachmentManageCells;
